import { lookup } from "dns";
import { appLog } from "./utils/app-log";

export const appEnv = import.meta.env.VITE_ENV;
export const appVersionLabel = import.meta.env.VITE_VersionLabel;
export const appBuildLabel = import.meta.env.VITE_BuildLabel;

export const apimUrl = import.meta.env.VITE_APIM_URL;
export const apimSubKey = import.meta.env.VITE_APIM_SUB_KEY;

export const appRealm = import.meta.env.VITE_REALM;
export const appAuthUrl = import.meta.env.VITE_AUTHSERVERURL;


export const domianTableUrl = import.meta.env.VITE_DOMAIN_TABLES_BASEURL;
export const domianTableSubKey = import.meta.env.VITE_DOMAIN_TABLES_SUBSCRIPTION_Key;
export const domianTableLookupIdEquimentType = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_EQUIPMENT_TYPE;
export const domianTableLookupIdTickStatus = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_STATUS;
export const domianTableLookupIdForestrArea = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_FORESTAREA;
export const domianTableLookupIdResourceType = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_RESOURCETYPE;

export const domianTableLookupIdUnitType = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_UNITTYPE;



export const domianTableLookupIdCostCenter = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_COSTCENTER;
export const domianTableLookupIdCostingActivity = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_COSTINGACTIVITY;
export const domianTableLookupIdCostRateType = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_COSTRATETYPE;
export const domianTableLookupIdEquipmentSpecifications = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_EQUIPMENT_SPECIFICATIONS;

export const domianTableRelationshipForestAreaCostCenterId = import.meta.env.VITE_DOMAIN_TABLES_RELATION_ForestAreaCostCenter;
export const domianTableRelationshipEquipmentSpecRatePerUnitId = import.meta.env.VITE_DOMAIN_TABLES_RELATION_EquipmentSpecRatePerUnit;

export const domianTableFeature = import.meta.env.VITE_DOMAIN_TABLES_FEATUREID;
export const domianTableRelationshipRateTypeCostingActivityId = import.meta.env.VITE_DOMAIN_TABLES_RELATION_RateTypeCostingActivity;

// Lookup-relationship key used to fetch the "Work performed" activity list
export const domianTableRelationshipKeyWorkPerformed = import.meta.env.VITE_DOMAIN_TABLES_RELATIONKEY_WORKPERFORMED;
// lookupTypeId identifying the "Worked Performed" itemElements within
// the WORK_PERFORMED lookup-relationships/key response (see ApiService.loadLookupData).
export const domianTableLookupIdWorkPerformed = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_WORKPERFORMED;
// lookupTypeId identifying the "Assigned To Wildfire" and "Fuel Provided by GoA" itemElements within
// the same WORK_PERFORMED lookup-relationships/key response - used to determine, per selected
// "Work performed" item, whether those questions should be shown in the Add/Edit drawer.
export const domianTableLookupIdAssignedToWildfire = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_ASSIGNEDTOWILDFIRE;
export const domianTableLookupIdFuelProvidedByGoa = import.meta.env.VITE_DOMAIN_TABLES_LOOKUPID_FUELPROVIDEDBYGOA;

// ADSP PDF Service - PDF generation is called directly from the browser
export const appPdfServiceUrl = import.meta.env.VITE_PDF_SERVICE_URL;
export const appPdfServiceKey = import.meta.env.VITE_PDF_SERVICE_SUB_KEY;
export const appPdfTemplateId = import.meta.env.VITE_PDF_TEMPLATE_ID || "time-tracking-ticket";





export const aviationApiUrl = import.meta.env.VITE_AVIATION_API_URL;
export const aviationSubKey = import.meta.env.VITE_AVIATION_SUB_KEY;
// Fires
export const firesUrl = import.meta.env.VITE_FIRES_BASEURL;
export const firesSubKey = import.meta.env.VITE_FIRES_SUB_KEY;
// Finace
export const financeUrl = import.meta.env.VITE_FINANCE_BASEURL;
export const financeSubKey = import.meta.env.VITE_FIRES_SUB_KEY;


export const firesSubKey1 = '204bffb17d5e4dc4be7793919a183819';
export const phoneFormat = "xxx-xxx-xxxx";
export const dateFormat = "YYYY-MM-DD";
export const dateTimeFormat = "MM/DD/YYYY HH:mm";
export const tz = "America/Edmonton";

// Environment Types
type Environment = 'dev' | 'uat' | 'prod';

// Application Strings
export const appStrings = {
  portalUrlDev: 'https://wildfireapps-dev.alberta.ca/',
  portalUrlUat: 'https://goa-wdp-wildfire-uat.azurewebsites.net/',
  portalUrlProd: 'https://goa-wdp-wildfire.azurewebsites.net/',
  noAddOns: "Without Add Ons",
  ticketExists:"Ticket number already exists. Enter a unique number.",
  internalOrderNotMatchFireNo:"When a fire number is selected, the internal order must match the same fire number and year."
};

// application Regexs
export const appRegexs = {
  //emailRegex        : /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  //phoneRegex        : /^(?:\d{3}-)\d{3}-\d{4}$/,
  //fireNumberRegex   : /^[a-zA-Z0-9-_]+$/,
  ticketNumber: /^[Ee]\d{7}$/,
  date: /^\d{4}-\d{2}-\d{2}$/,

};

// Application Constants
export const mandatoyFields       = ["date", "ticketNumber", 'contractNumber', 'contractorName', 'forestAreaId', 'unitNumber', 'serialNumber', 'equipment', 'costSummary', "costActivityCode", "rateType", "noOfUnits", "rateUnit", "ratePerUnit", "costCenter", "fund", "account"];
export const basicFields          = ['ticketNumber','date','contractNumber','contractorName','forestAreaId','standbyBase','fieldSupervisor','unitNumber','serialNumber','equipment','addOns'] as const;

// Rate Types
export const RateType_Dry              = "Dry";
export const RateType_Standard         = "Standard";
export const RateType_StandBy          = "StandBy";
export const RateType_OffShift         = "OffShift";
export const RateType_OffShiftOnCall   = "Off-Shift On Call";
export const RateType_PotableWater      = "Potable Water";
export const RateType_Swamper           = "Swamper";
export const RateType_FuelSurcharge     = "Fuel Surcharge";
export const RateType_Travel            = "Travel";
export const RateType_CrewExpLunch      = "Crew Exp - Lunch";
export const RateType_CrewExpDinner     = "Crew Exp - Dinner";
export const RateType_CrewExpBreakfast  = "Crew Exp - Breakfast";
export const RateType_Accommodation     = "Accommodation";

// Rate Types Groupings
export const RatesFromFires       = [RateType_Dry, RateType_Standard, RateType_StandBy, RateType_OffShift,  RateType_OffShiftOnCall];
export const workRateType         = [...RatesFromFires, RateType_PotableWater, RateType_Swamper, RateType_FuelSurcharge];
export const MealCostRateType     = [RateType_CrewExpLunch, RateType_CrewExpDinner, RateType_CrewExpBreakfast];
export const LodgingCostRateType  = [RateType_Accommodation];
export const TravelCostRateType   = [RateType_Travel];

// Ticket Statuses
export type TicketStatusLookupKey = 
  'NOT-SUBMITTED' | 'SUBMITTED' | 'NEEDS-ATTENTION'  
  | 'IN-PROGRESS' | 'SIGNED-OFF' | 'APPROVED' | 'PROCESSED';
export interface TicketStatusItem {
  lookupKey: TicketStatusLookupKey;
  lookupId: number;
}
// NOTE: uat/prod are missing NOT-SUBMITTED, SUBMITTED and NEEDS-ATTENTION entries - any lookup
// for those keys returns undefined in those environments (see getStatusLookupItemByKey usages).
const EnvTicketStatuses: Record<Environment, TicketStatusItem[]> = {
  dev: [
    { lookupKey: "NOT-SUBMITTED",   lookupId: 14239 },
    { lookupKey: "SUBMITTED",       lookupId: 9652 },
    { lookupKey: "NEEDS-ATTENTION", lookupId: 14225 },
    { lookupKey: "IN-PROGRESS",     lookupId: 1347 },
    { lookupKey: "APPROVED",        lookupId: 9653 },
    { lookupKey: "PROCESSED",       lookupId: 9654 },
    { lookupKey: "SIGNED-OFF",      lookupId: 10931 },
  ],
  uat: [
    { lookupKey: "NOT-SUBMITTED",   lookupId: 22559 },
    { lookupKey: "SUBMITTED",       lookupId: 20707 },
    { lookupKey: "NEEDS-ATTENTION", lookupId: 22558 },
    { lookupKey: "IN-PROGRESS",     lookupId: 1634 },
    { lookupKey: "APPROVED",        lookupId: 20704 },
    { lookupKey: "PROCESSED",       lookupId: 20708 },
    { lookupKey: "SIGNED-OFF",      lookupId: 20706 },
  ],
  prod: [
    // { lookupKey: "NOT-SUBMITTED",   lookupId:  },  later 
    // { lookupKey: "SUBMITTED",       lookupId:  },  later 
    // { lookupKey: "NEEDS-ATTENTION", lookupId:  },  later 
    { lookupKey: "IN-PROGRESS", lookupId: 1634 },
    { lookupKey: "APPROVED",    lookupId: 8786 },
    { lookupKey: "PROCESSED",   lookupId: 8787 },
    { lookupKey: "SIGNED-OFF",  lookupId: 8788 },
    
  ],
};
appLog.debug("Current Environment:", import.meta.env.VITE_ENV);
export const TicketStatuses: TicketStatusItem[] = EnvTicketStatuses[import.meta.env.VITE_ENV as Environment] || EnvTicketStatuses.dev;